import type { RouteRecordRaw } from 'vue-router'

// Sección pausada a pedido del cliente (First Cash) hasta que se ajuste: ver
// el bloque de "hoteles/facturas" comentado en UserDashboard.vue y el nav de
// useAuth.ts. Se deja la ruta activa con un aviso honesto en vez de comentarla
// del todo — un cliente con /invoices en favoritos merece un mensaje, no un
// 404 pelón. Cuando se reactive de verdad, restaurar el import de
// InvoicesPage.vue y el guard de companyId que tenía antes.
export default {
  path: '/invoices',
  name: 'invoices.index',
  component: () => import('@/components/SectionPausedPage.vue'),
} as RouteRecordRaw
